import React from 'react';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { NoteMode } from '../types/notes';

interface ModeToggleProps {
  mode: NoteMode;
  onModeChange: (mode: NoteMode) => void;
}

export const ModeToggle: React.FC<ModeToggleProps> = ({ 
  mode, 
  onModeChange 
}) => {
  return (
    <Card className="absolute top-4 left-1/2 transform -translate-x-1/2 z-20 shadow-lg">
      <div className="p-3">
        <div className="flex rounded-lg border p-1 bg-gray-50">
          <Button
            variant={mode === 'capturing' ? 'default' : 'ghost'}
            size="sm"
            onClick={() => onModeChange('capturing')}
            className="px-6 text-sm font-medium"
          >
            📝 Capturing
          </Button>
          <Button
            variant={mode === 'analysing' ? 'default' : 'ghost'}
            size="sm"
            onClick={() => onModeChange('analysing')}
            className="px-6 text-sm font-medium"
          >
            🔍 Analysing
          </Button>
        </div>
      </div>
    </Card>
  );
};